module.exports = __webpack_public_path__ + "media/club/canofea-edit-8a7d067b.webp";